import { getResolvedLocale } from '../date/localize.js';

const CURRENCY_DEFAULT_LOCALE: Record<string, string> = {
  ZAR: 'en-ZA',
  NGN: 'en-NG',
  KES: 'en-KE',
  USD: 'en-US',
  EUR: 'en-IE',
  GBP: 'en-GB'
};

const MINOR_UNIT_DIVISORS: Record<string, number> = {
  // most currencies use 100; the divisor is the multiplier from major→minor
  JPY: 1, KRW: 1, VND: 1
};

function divisor(currency: string): number {
  return MINOR_UNIT_DIVISORS[currency.toUpperCase()] ?? 100;
}

export function formatCurrency(amount: number, currency: string, locale?: string): string {
  const resolved = locale ?? CURRENCY_DEFAULT_LOCALE[currency.toUpperCase()] ?? getResolvedLocale();
  return new Intl.NumberFormat(resolved, { style: 'currency', currency }).format(amount);
}

export function formatMinor(minorUnits: number, currency: string, locale?: string): string {
  const major = minorUnits / divisor(currency);
  return formatCurrency(major, currency, locale);
}

export function parseCurrency(input: string, currency: string): number {
  const cleaned = input.replace(/[^\d.,-]/g, '').replace(/,/g, '.');
  const value = parseFloat(cleaned);
  if (Number.isNaN(value)) return NaN;
  return Math.round(value * divisor(currency));
}
